(() => {
  'use strict';
  const boot = () => {
    const root = document.querySelector('[data-psgc]');
    if (!root || root.dataset.lifeReady) return;
    const source = root.querySelector('.psgc-mascot-idle');
    const launcher = root.querySelector('[data-psgc-mascot]');
    const button = root.querySelector('[data-psgc-open]');
    const dialog = root.querySelector('dialog');
    const base = source?.querySelector('[data-psgc-mascot-image]');
    const defs = source?.querySelector('defs');
    const hand = source?.querySelector('.psgc-mascot-hand');
    if (!base || !defs || !hand || !launcher || !button || !dialog || typeof base.animate !== 'function') return;
    root.dataset.lifeReady = 'natural-v2';
    const greeting = root.querySelector('[data-psgc-greeting]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const ns = 'http://www.w3.org/2000/svg';
    const motions = new Set();
    const recoveries = new Map();
    let timer, finishTimer, breath, act = '', paused = false, hovered = false;
    let lastActivity = Date.now(), lastScroll = 0, lastRest = 0;
    let nextBlink = Date.now() + 1800, nextGesture = Date.now() + 3200;
    let acknowledgement = false, lastGuide;
    let greetingWasVisible = !!greeting && !greeting.hidden, speechPending = greetingWasVisible;
    const random = (min, max) => min + Math.random() * (max - min);
    const svg = (tag, attrs, parent) => {
      const el = document.createElementNS(ns, tag);
      Object.entries(attrs || {}).forEach(([key, value]) => el.setAttribute(key, String(value)));
      if (parent) parent.append(el);
      return el;
    };
    const clip = (id, path) => svg('path', { d: path }, svg('clipPath', { id }, defs));
    clip('DroppeNaturalBody', 'M0 0H74.5V62H100V100H66.8V79.7H49.8V100H45V79.7H28.5V100H0Z');
    clip('DroppeNaturalFootLeft', 'M28.5 79.2H45V100H28.5Z');
    clip('DroppeNaturalFootRight', 'M49.8 79.2H66.8V100H49.8Z');
    const imageLayer = (className, clipId, parent) => {
      const group = svg('g', { class: className }, parent);
      const image = base.cloneNode(true);
      image.removeAttribute('data-psgc-mascot-image');
      image.setAttribute('clip-path', 'url(#' + clipId + ')');
      group.append(image);
      return group;
    };
    const leftFoot = imageLayer('droppe-natural-foot droppe-natural-foot--left', 'DroppeNaturalFootLeft', source);
    imageLayer('droppe-natural-foot droppe-natural-foot--right', 'DroppeNaturalFootRight', source);
    const chest = svg('g', { class: 'droppe-natural-breath' }, source);
    const pose = svg('g', { class: 'droppe-natural-pose' }, chest);
    pose.append(base, hand);
    base.setAttribute('clip-path', 'url(#DroppeNaturalBody)');
    const mouthClip = svg('clipPath', { id: 'DroppeNaturalMouth' }, defs);
    svg('ellipse', { cx: 47.6, cy: 61.6, rx: 13.4, ry: 5.8 }, mouthClip);
    // Sample the character's own water texture underneath the mouth. The soft
    // edge hides the original smile so the animated mouth can actually close.
    const feather = svg('radialGradient', { id: 'DroppeNaturalSkinFade' }, defs);
    [[0, 1], [.82, 1], [1, 0]].forEach(([offset, opacity]) => svg('stop', { offset, 'stop-color': '#fff', 'stop-opacity': opacity }, feather));
    const skinMask = svg('mask', { id: 'DroppeNaturalSkinMask', maskUnits: 'userSpaceOnUse', x: 32, y: 54, width: 32, height: 15 }, defs);
    svg('ellipse', { cx: 47.6, cy: 61.6, rx: 15.1, ry: 7, fill: 'url(#DroppeNaturalSkinFade)' }, skinMask);
    const skin = svg('g', { mask: 'url(#DroppeNaturalSkinMask)' }, pose);
    const texture = base.cloneNode(true);
    texture.removeAttribute('data-psgc-mascot-image');
    texture.removeAttribute('clip-path');
    texture.setAttribute('transform', 'translate(0 -10)');
    skin.append(texture);
    const mouth = imageLayer('droppe-natural-mouth', 'DroppeNaturalMouth', pose);
    const lidGradient = svg('linearGradient', { id: 'DroppeNaturalLid', x1: 0, y1: 0, x2: '.25', y2: 1 }, defs);
    [[0, '#dbf4ff'], [.34, '#b8dcef'], [.72, '#8dbcd8'], [1, '#d0edfa']].forEach(([offset, color]) => svg('stop', { offset, 'stop-color': color }, lidGradient));
    const lids = [], seams = [];
    [37.5, 58.1].forEach((x, i) => {
      const id = 'DroppeNaturalEye' + i;
      const eyeClip = svg('clipPath', { id }, defs);
      svg('ellipse', { cx: x, cy: 45.7, rx: 8.45, ry: 9.25 }, eyeClip);
      const socket = svg('g', { 'clip-path': 'url(#' + id + ')' }, pose);
      const lid = svg('g', { class: 'droppe-natural-lid' }, socket);
      svg('ellipse', { cx: x, cy: 45.7, rx: 8.6, ry: 9.4, fill: 'url(#DroppeNaturalLid)' }, lid);
      svg('path', { d: `M${x - 6.5} 42Q${x - 1} 37.4 ${x + 5.5} 40.5`, fill: 'none', stroke: '#f1fcff', 'stroke-opacity': .6, 'stroke-width': .45 }, lid);
      const seam = svg('path', { class: 'droppe-natural-seam', d: `M${x - 7} 48Q${x} 51.4 ${x + 7} 47.8`, fill: 'none', stroke: '#39718f', 'stroke-width': .65, 'stroke-linecap': 'round' }, socket);
      lids.push(lid); seams.push(seam);
    });
    source.classList.add('droppe-natural');
    source.setAttribute('aria-hidden', 'true');
    const typing = () => document.activeElement?.matches('textarea,select,[contenteditable="true"],input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"])');
    const overlay = () => [...document.querySelectorAll('dialog[open],[aria-modal="true"],[data-psh-mini-panel]:not([hidden]),#shopify-pc__banner,#shopify-pc__prefs')].some(el => el !== dialog && !el.hidden && getComputedStyle(el).visibility !== 'hidden' && el.getClientRects().length);
    const available = (allowHover = false) => root.isConnected && !paused && !document.hidden && !reduced.matches && !dialog.open && !button.hidden && launcher.classList.contains('is-art-ready') && !launcher.matches('.is-returning,.is-falling,.is-fallen,.is-obscured,.is-curious') && !root.classList.contains('is-water-entering') && (!hovered || allowHover) && !button.matches(':focus-visible') && !typing() && !overlay() && Date.now() - lastScroll > 1500;
    const greetingVisible = () => !!greeting && !greeting.hidden;
    const play = (el, frames, duration, options = {}) => {
      const current = getComputedStyle(el);
      const first = { ...frames[0] };
      if ('transform' in first) first.transform = current.transform;
      if ('opacity' in first) first.opacity = current.opacity;
      recoveries.get(el)?.cancel(); recoveries.delete(el);
      frames = [first, ...frames.slice(1)];
      const animation = el.animate(frames, { duration, easing: 'ease-in-out', fill: 'both', ...options });
      motions.add(animation);
      animation.onfinish = () => { motions.delete(animation); animation.cancel(); };
      return animation;
    };
    const stop = () => {
      clearTimeout(finishTimer);
      const smooth = !reduced.matches && !document.hidden && !root.classList.contains('is-water-entering') && !dialog.open;
      const targets = new Map();
      if (smooth) {
        [...motions, ...(breath ? [breath] : [])].forEach(animation => {
          const el = animation.effect?.target;
          if (!el || targets.has(el)) return;
          const current = getComputedStyle(el);
          targets.set(el, { transform: current.transform, opacity: current.opacity });
        });
      }
      motions.forEach(animation => animation.cancel());
      motions.clear();
      breath?.cancel(); breath = undefined;
      if (!smooth) { recoveries.forEach(animation => animation.cancel()); recoveries.clear(); }
      targets.forEach((from, el) => {
        recoveries.get(el)?.cancel();
        const base = getComputedStyle(el);
        const animation = el.animate([from, { transform: base.transform, opacity: base.opacity }], { duration: 240, easing: 'ease-out', fill: 'both' });
        recoveries.set(el, animation);
        animation.onfinish = () => { if (recoveries.get(el) === animation) recoveries.delete(el); animation.cancel(); };
      });
      act = '';
      source.removeAttribute('data-droppe-act');
    };
    const breathe = () => {
      if (!breath && !recoveries.has(chest)) breath = chest.animate([
        { transform: 'scale(1,1)' },
        { transform: 'scale(1.004,1.008)', offset: .46 },
        { transform: 'scale(1,1)' }
      ], { duration: 3900, iterations: Infinity, easing: 'ease-in-out' });
    };
    const blink = (double = false) => {
      const frames = double ? [
        { opacity: 0, transform: 'scaleY(.02)' }, { opacity: 1, transform: 'scaleY(1)', offset: .17 },
        { opacity: 0, transform: 'scaleY(.02)', offset: .39 }, { opacity: 0, transform: 'scaleY(.02)', offset: .59 },
        { opacity: 1, transform: 'scaleY(1)', offset: .76 }, { opacity: 0, transform: 'scaleY(.02)' }
      ] : [
        { opacity: 0, transform: 'scaleY(.02)' }, { opacity: 1, transform: 'scaleY(1)', offset: .36 },
        { opacity: 1, transform: 'scaleY(1)', offset: .47 }, { opacity: 0, transform: 'scaleY(.02)' }
      ];
      lids.forEach(el => play(el, frames, double ? 540 : 220));
      seams.forEach(el => play(el, frames.map(f => ({ opacity: f.transform === 'scaleY(1)' ? 1 : 0, offset: f.offset })), double ? 540 : 220));
      nextBlink = Date.now() + random(2200, 4800);
    };
    const smile = duration => play(mouth, [
      { transform: 'scale(1,.68)' }, { transform: 'scale(1.025,1.06)', offset: .34 },
      { transform: 'scale(.98,.42)', offset: .68 }, { transform: 'scale(1,.68)' }
    ], duration);
    const begin = (name, duration, draw, allowHover = false) => {
      if (!available(allowHover) || act) return false;
      act = name; source.dataset.droppeAct = name;
      draw();
      finishTimer = setTimeout(() => { act = ''; source.removeAttribute('data-droppe-act'); }, duration);
      return true;
    };
    const settle = () => begin('settle', 2900, () => {
      play(pose, [{ transform: 'rotate(0deg)' }, { transform: 'rotate(1.4deg)', offset: .4 }, { transform: 'rotate(-.45deg)', offset: .75 }, { transform: 'rotate(0deg)' }], 2900);
      play(leftFoot, [{ transform: 'rotate(0deg)' }, { transform: 'rotate(-3.5deg)', offset: .4 }, { transform: 'rotate(0deg)' }], 2900);
      play(hand, [{ transform: 'rotate(118deg)' }, { transform: 'rotate(114deg)', offset: .3 }, { transform: 'rotate(121deg)', offset: .7 }, { transform: 'rotate(118deg)' }], 2900);
      smile(2400);
    });
    const nod = () => begin('nod', 1800, () => {
      play(pose, [{ transform: 'translateY(0) rotate(0deg)' }, { transform: 'translateY(.9px) rotate(-1.2deg)', offset: .38 }, { transform: 'translateY(-.2px) rotate(.35deg)', offset: .7 }, { transform: 'translateY(0) rotate(0deg)' }], 1800);
      smile(1800);
    });
    const speak = () => begin('speak', 3200, () => {
      const shapes = [[0, .68], [.1, 1.08], [.19, .32], [.28, .94], [.39, .45], [.47, 1.12], [.57, .38], [.68, .95], [.78, .43], [.88, 1.02], [1, .68]];
      play(mouth, shapes.map(([offset, opening]) => ({ offset, transform: `scale(1,${opening})` })), 3200);
      play(hand, [{ transform: 'rotate(118deg)' }, { transform: 'rotate(106deg)', offset: .25 }, { transform: 'rotate(121deg)', offset: .62 }, { transform: 'rotate(118deg)' }], 3200);
      play(pose, [{ transform: 'rotate(0deg)' }, { transform: 'rotate(-1.2deg)', offset: .3 }, { transform: 'rotate(.6deg)', offset: .7 }, { transform: 'rotate(0deg)' }], 3200);
    });
    const hello = () => begin('hello', 2200, () => {
      play(hand, [{ transform: 'rotate(118deg)' }, { transform: 'rotate(44deg)', offset: .34 }, { transform: 'rotate(51deg)', offset: .48 }, { transform: 'rotate(42deg)', offset: .62 }, { transform: 'rotate(118deg)' }], 2200);
      smile(2200);
    }, true);
    const rest = () => begin('rest', 7000, () => {
      lastRest = Date.now();
      lids.forEach(el => play(el, [{ opacity: 0, transform: 'scaleY(.02)' }, { opacity: 1, transform: 'scaleY(1)', offset: .2 }, { opacity: 1, transform: 'scaleY(1)', offset: .88 }, { opacity: 0, transform: 'scaleY(.02)' }], 7000));
      seams.forEach(el => play(el, [{ opacity: 0 }, { opacity: 1, offset: .2 }, { opacity: 1, offset: .88 }, { opacity: 0 }], 7000));
      play(pose, [{ transform: 'translateY(0) rotate(0deg)' }, { transform: 'translateY(.7px) rotate(1.2deg)', offset: .22 }, { transform: 'translateY(.7px) rotate(1.2deg)', offset: .86 }, { transform: 'translateY(0) rotate(0deg)' }], 7000);
    });
    const gestures = { settle };
    const schedule = delay => { clearTimeout(timer); if (!paused && !document.hidden && !reduced.matches) timer = setTimeout(tick, delay); };
    const tick = () => {
      if (!root.isConnected) { stop(); return; }
      if (!available(act === 'hello')) { stop(); schedule(600); return; }
      breathe();
      const now = Date.now();
      if (act !== 'rest' && now >= nextBlink) blink(Math.random() < .16);
      if (!act) {
        if (speechPending && greetingVisible()) { speechPending = false; speak(); nextGesture = now + random(5000, 7500); }
        else if (acknowledgement) { acknowledgement = false; nod(); nextGesture = now + random(4500, 7000); }
        else if (!greetingVisible() && now - lastActivity >= 60000 && now - lastRest >= 120000) { rest(); nextBlink = now + 8500; nextGesture = now + 10000; }
        else if (now >= nextGesture) {
          const choices = Object.keys(gestures);
          const name = choices[Math.floor(Math.random() * choices.length)];
          gestures[name]();
          nextGesture = now + random(12000, 22000);
        }
      }
      schedule(400);
    };
    const activity = event => {
      lastActivity = Date.now();
      if (event.type === 'scroll') lastScroll = lastActivity;
      if (act === 'rest' || ['scroll', 'pointerdown', 'keydown', 'focusin'].includes(event.type) || typing()) {
        stop(); nextGesture = lastActivity + random(3000, 5000); schedule(1800);
      }
    };
    const interrupt = () => { lastActivity = Date.now(); stop(); nextGesture = lastActivity + 3500; schedule(1800); };
    button.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; interrupt(); hello(); schedule(400); } });
    button.addEventListener('pointerleave', () => { hovered = false; schedule(400); });
    button.addEventListener('pointerdown', interrupt, { capture: true });
    button.addEventListener('click', interrupt, { capture: true });
    button.addEventListener('focus', interrupt);
    ['pointerdown', 'keydown', 'focusin', 'pointermove', 'touchmove', 'wheel'].forEach(type => document.addEventListener(type, activity, { passive: true }));
    document.addEventListener('scroll', activity, { passive: true, capture: true });
    window.addEventListener('hashchange', activity);
    window.addEventListener('popstate', activity);
    document.addEventListener('psh:guide-scene', event => {
      if (!event.detail?.interactive || event.detail.stage !== 'result' || lastGuide === event.target || reduced.matches) return;
      lastGuide = event.target; acknowledgement = true;
    });
    const observer = new MutationObserver(() => {
      const visible = greetingVisible();
      if (visible && !greetingWasVisible) { speechPending = true; schedule(100); }
      if (!visible) speechPending = false;
      greetingWasVisible = visible;
      if (!available(act === 'hello')) stop();
    });
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    observer.observe(launcher, { attributes: true, attributeFilter: ['class'] });
    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    if (greeting) observer.observe(greeting, { attributes: true, attributeFilter: ['hidden'] });
    dialog.addEventListener('close', interrupt);
    const suspend = () => { clearTimeout(timer); stop(); };
    document.addEventListener('visibilitychange', () => { if (document.hidden) suspend(); else { lastActivity = Date.now(); schedule(2000); } });
    reduced.addEventListener('change', () => { suspend(); acknowledgement = false; schedule(2000); });
    window.addEventListener('resize', interrupt, { passive: true });
    window.addEventListener('pagehide', () => { paused = true; suspend(); });
    window.addEventListener('pageshow', () => { paused = false; lastActivity = Date.now(); schedule(2000); });
    schedule(2200);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
